import Navibar from "./Navibar";
import IntroLandning from "./IntroLandning";
import Course from "./Course";
import CourseItem from "./CourseItem";
import HowItWorks from "./HowItWorks";
import HowItWorksItem from "./HowItWorksItem";
import OurClients from "./OurClients";
import OurTeam from "./OurTeam";
import InfoOurSite from "./InfoOurSite";
import Footer from "./Footer";

export {
    Navibar,
    IntroLandning,
    Course,
    CourseItem,
    HowItWorks,
    HowItWorksItem,
    OurClients,
    OurTeam,
    InfoOurSite,
    Footer,
}


// WEBPACK FOOTER //
// ./src/components/homepage/index.ts